import { useMutation } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { components } from '@/api/generated/schema';

type CreateCustomOrderPayload = components['schemas']['PixlideApplicationFeaturesVideoProjectsCreateCustomOrderProjectCommand'];

/** Commande d'une création sur-mesure : le back-office Pixlide produit la vidéo sous 48h. */
export function useCreateCustomOrder() {
  return useMutation({
    mutationFn: async (payload: CreateCustomOrderPayload) => {
      const { data } = await api.POST('/api/v1/projects/custom-orders', { body: payload });

      return data!;
    },
  });
}
